import { IFontStyles, IStackItemStylesReturnType, Stack } from "@fluentui/react";
import React from "react";

import { Link } from "../navigations/Link";
import { TooltipHost } from "../surfaces/tooltip/TooltipHost";
import { Theme } from "../theme/Theme";
import { Icon } from "./Icon";
import { Text } from "./Text";

interface IconTextProps {
    text: string;
    iconName: string;
    iconColor?: string;
    gapWidth?: number;
    isTextFirst?: boolean;
    tooltip?: string;
    href?: string;
    openInNewTab?: boolean;
    textVariant?: keyof IFontStyles;
    testAttributes?: { [key: string]: string | undefined };
    styles?: IStackItemStylesReturnType;
}

export const IconText: React.VFC<IconTextProps> = ({
    text,
    iconName,
    iconColor,
    gapWidth,
    isTextFirst,
    tooltip,
    href,
    openInNewTab,
    textVariant,
    testAttributes,
    styles
}: IconTextProps) => {
    const renderText = () => {
        if (href !== undefined) {
            return (
                <TooltipHost content={tooltip}>
                    <Link
                        href={`#${href}`}
                        target={openInNewTab ? "_blank" : "_self"}
                        styles={{ root: { color: Theme.palette.neutralPrimary } }}
                        testAttributes={testAttributes}
                    >
                        {text}
                    </Link>
                </TooltipHost>
            );
        }

        return (
            <TooltipHost content={tooltip}>
                <Text variant={textVariant}>{text}</Text>
            </TooltipHost>
        );
    };

    return (
        <Stack
            horizontal={true}
            tokens={{ childrenGap: gapWidth ?? 10 }}
            verticalAlign="center"
            styles={styles}
            {...testAttributes}
        >
            {isTextFirst && renderText()}
            <Icon iconName={iconName} color={iconColor} />
            {!isTextFirst && renderText()}
        </Stack>
    );
};
